export function useLocationHash() {
    // Helper function to check if a hash exists
    const hashExists = () => {
        return window.location.hash.length > 1;
    };

    // Function to search the hash for an existing key
    const searchHash = (key) => {
        if (!hashExists()) return;

        const hashParts = window.location.hash.replace(/^#/, '').split('&').map((parameter) => {
            const parameterParts = parameter.split('=');
            return {
                label: parameterParts[0],
                value: decodeURI(parameterParts[1])
            };
        });

        return hashParts.find((parameter) => {
            return parameter.label === key;
        });
    };

    // Function to replace a key in the hash
    const replaceHash = (key, value) => {
        const regex = new RegExp(`${key}=[^&]*`);
        const newHash = `${key}=${value}`;
        window.location.hash = window.location.hash.replace(regex, newHash);
    };

    // Function to add a key-value pair to the hash
    const addToHash = (key, value) => {
        const hash = `${key}=${value}`;

        if (searchHash(key)) {
            return replaceHash(key, value);
        }

        if (window.location.hash.startsWith('#')) {
            window.location.hash += `&${hash}`;
        } else {
            window.location.hash = `#${hash}`;
        }
    };

    return {
        hashExists,
        searchHash,
        replaceHash,
        addToHash,
    };
};
